import React from 'react';

interface DecisionTreeSequenceTransitionContextProps {
  transitioning: boolean;
}

export const DecisionTreeSequenceTransitionContext = React.createContext<DecisionTreeSequenceTransitionContextProps | null>(null);

export default function useDecisionTreeSequenceTransitionContext() {
  const context = React.useContext(DecisionTreeSequenceTransitionContext);
  if (context === null) {
    throw new Error('useDecisionTreeSequenceTransitionContext must be used within a DecisionTreeSequenceTransitionContextProvider');
  }
  return context;
}
